module.exports = require("./../../_gen/openfl/events/UncaughtErrorEvents");